export enum BettingOptionStatus {
    WON = 'won',
    LOST = 'lost',
    ACTIVE = 'active',
    PUSH = 'push',
    INACTIVE = 'inactive',
}
